/* ==========================================================================
   TWCA GALLERY JS  —  desktop hero arrows only.
   On desktop (vertical thumbnails) Dawn does NOT wire the hero arrows to
   navigate, so we route a hero-arrow click to the next/prev THUMBNAIL click
   (same idea AU used, but vanilla — no jQuery). Mobile is left 100% native
   (its swipe slider already works), so we bail out below 750px.
   ========================================================================== */
(function () {
  var DESKTOP = '(min-width: 750px)';

  function arrowsFor(gallery) {
    return {
      prev: gallery.querySelector(
        'slider-component.slider-mobile-gutter:not(.thumbnail-slider) .slider-button--prev'
      ),
      next: gallery.querySelector(
        'slider-component.slider-mobile-gutter:not(.thumbnail-slider) .slider-button--next'
      )
    };
  }

  /* hide the arrow at the first / last image on desktop (mobile uses native) */
  function syncEnds(gallery, index, total) {
    var a = arrowsFor(gallery);
    if (a.prev) a.prev.toggleAttribute('disabled', index <= 0);
    if (a.next) a.next.toggleAttribute('disabled', index >= total - 1);
  }

  function thumbsIn(gallery) {
    return Array.prototype.slice.call(
      gallery.querySelectorAll('.thumbnail-list__item .thumbnail')
    );
  }

  function activeIndex(thumbs) {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].hasAttribute('aria-current')) return i;
    }
    return 0;
  }

  function onClick(e) {
    var btn = e.target.closest(
      '.product__media-gallery slider-component.slider-mobile-gutter:not(.thumbnail-slider) .slider-button'
    );
    if (!btn) return;
    if (!window.matchMedia(DESKTOP).matches) return; // mobile = native, do nothing

    var gallery = btn.closest('.product__media-gallery');
    if (!gallery) return;
    var thumbs = thumbsIn(gallery);
    if (thumbs.length < 2) return;

    var idx = activeIndex(thumbs);
    var target = btn.classList.contains('slider-button--next') ? idx + 1 : idx - 1;
    if (target < 0 || target >= thumbs.length) return; // at an end — nothing to do

    e.preventDefault();
    e.stopImmediatePropagation(); // beat Dawn's own (no-op here) handler
    thumbs[target].click();        // this is what actually changes the hero image
    syncEnds(gallery, target, thumbs.length);
  }

  function init() {
    if (!window.matchMedia(DESKTOP).matches) return;
    document.querySelectorAll('.product__media-gallery').forEach(function (gallery) {
      var thumbs = thumbsIn(gallery);
      if (thumbs.length < 2) return;
      syncEnds(gallery, activeIndex(thumbs), thumbs.length);
    });
  }

  // capture phase so we intercept before Dawn's listener
  document.addEventListener('click', onClick, true);
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
